export const LIMITS_DATA = "LIMITS_DATA";
export const LIMITS_ERROR_DATA = "LIMITS_ERROR_DATA";
export const LIMITS_HIDE_ERROR_DATA = "LIMITS_HIDE_ERROR_DATA";
export const LIMITS_START_LOADER = "LIMITS_START_LOADER";
export const LIMITS_STOP_LOADER = "LIMITS_STOP_LOADER";
